<mat-form-field class="user-control-container" appearance="outline">
  <mat-label translate="reviewers"></mat-label>
  <mat-chip-grid #chipList [attr.aria-label]="'modal-video-share-dialog_user-select-aria-label' | translate">
    @for (user of selectedUsers.value; track user) {
      <mat-chip-row
        [ngClass]="{ 'invalid': user.invalid }"
        [removable]="removable"
        (removed)="remove(user)">
        {{ getChipDisplay(user) }}
        @if (removable) {
          <button matChipRemove>
            <i class="ficon-app-x"></i>
          </button>
        }
      </mat-chip-row>
    }
    <input
      placeholder="{{'modal-video-share-dialog_placeholder' | translate}}"
      #userInput
      data-cy="users-field"
      [formControl]="userInputCtrl"
      [matAutocomplete]="auto"
      [matChipInputFor]="chipList"
      [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
      (matChipInputTokenEnd)="add($event)">
  </mat-chip-grid>
  <mat-autocomplete #auto="matAutocomplete" (optionSelected)="selected($event);">
    @for (user of filteredUsers | async; track user) {
      <mat-option [value]="user">
        {{ user.first_name }} {{ user.last_name }}
      </mat-option>
    }
  </mat-autocomplete>
</mat-form-field>
@if (selectedUsers.hasError('invalidChip')) {
  <mat-error>
    {{ getValidationError() }}
  </mat-error>
}
